module.exports = __webpack_public_path__ + "static/img/news-cover.74609a14.png";